import {Component, Input, OnDestroy, OnInit, DestroyRef, inject} from "@angular/core";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ExcelService} from '@shared/services/global';
import {Subject} from 'rxjs';
import {castFloatFixed, castInt} from '@shared/utils';


@Component({
  standalone: false,
  selector: 'app-import-excel-common',
  template: `
      <div class="modal-header bg-light py-2">
        <h5 class="modal-title fw-semibold">
          <i class="fal fa-file-excel me-2"></i>
          Xuất dữ liệu ra excel
        </h5>
      </div>
      <div class="modal-body">
        @if (onlyPageCurrent) {
          <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated active"
              style="width: 100%;">
              <div class="d-flex align-items-center justify-content-center">
                <span class="fal fa-cog fa-spin me-2"></span>
                @if (onlyPageCurrent) {
                  <span>Đang xử lý dữ liệu</span>
                }
              </div>
            </div>
          </div>
        }
      
        @if (!onlyPageCurrent) {
          <div class="row">
            <div class="col-lg-6">
              <p class="mb-2">
                <span class="fal fa-cog fa-spin me-2"></span>
                Đang xuất dữ liệu:
                <span class="currentItem">{{ currentItem }}</span> /
                <span class="totalItems">{{ totalItems }}</span>
              </p>
            </div>
            <div class="clearfix"></div>
            <div class="col-12">
              <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated active"
                  style="width: {{ progressBar }}%;">
                  <span>{{ progressBar }}%</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="modal-footer p-2">
        <button type="button" class="btn btn-sm btn-warning" (click)="onCancel()">Hủy</button>
      </div>
      `,
})
export class ExportExcelModalComponent implements OnInit, OnDestroy {
  @Input() service!: ExcelService
  @Input() onlyPageCurrent = false;
  currentItem = 0;
  totalItems = 0;
  totalPages = 0;
  progressBar = 0;
  private readonly destroyRef = inject(DestroyRef);

  constructor(public activeModal: NgbActiveModal) {

  }

  ngOnInit() {
    if (this.onlyPageCurrent) {
      this.progressBar = 100;
    }
    this.service.progressPaginator.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: res => {
        if (res == null) {
          // Handler finnal
          this.onCancel();
          return;
        }
        const cal = res.page * res.pageSize;
        this.totalItems = res.totalItems;
        this.currentItem = cal > res.totalItems ? res.totalItems : cal;
        this.progressBar = castInt(castFloatFixed((res.page / res.totalPages) * 100));
      }
    })
  }

  ngOnDestroy() {
  }

  onCancel() {
    this.service.stopExcelPaging();
    this.activeModal.close(true);
  }
}
